import dayjs from 'dayjs'
import reportHelper from 'features/Report/reportHelper'
import _ from 'lodash'
import $ from 'jquery'
import SelectOptions from 'general/constants/SelectOptions'
import Utils from 'general/utils/Utils'

export const defaultValues = (params) => {
  /** @type {Array<FilterDefaultValueProp>} */
  const arr = [
    {
      label: 'Ký hiệu',
      alias: 'Ký hiệu',
      formName: 'serials',
      options: params.serials,
      value: _.isEmpty(params.serials)
        ? null
        : (params.serials[0]?.value ?? null),
      colSpan: 24,
      multiselect: true,
    },
    {
      label: ['Hoá đơn từ số', 'Đến số'],
      formName: ['fromNumberInvoice', 'toNumberInvoice'],
      alias: 'Số hoá đơn: Từ',
      separator: 'Đến',
      value: [null, null],
      restrict: {
        type: 'number',
        min: 1,
        max: 99999999,
      },
    },
    {
      label: 'Người lập hoá đơn',
      alias: 'Người lập',
      formName: 'accountIds',
      options: _.reduce(
        params.accounts,
        (prev, acc) => [
          ...prev,
          {
            value: acc.accountId,
            label: acc.fullname,
          },
        ],
        [{ value: null, label: 'Tất cả' }],
      ),
      value: null,
    },
    {
      label: 'Trạng thái phát hành',
      alias: 'Trạng thái phát hành',
      formName: 'statusReleaseInvoiceReports',
      options: SelectOptions.statusReleaseInvoiceReplace,
      value: SelectOptions.statusReleaseInvoiceReplace[0].value,
    },
    {
      label: 'Trạng thái hoá đơn',
      alias: 'Trạng thái HĐ',
      formName: 'types',
      options: SelectOptions.invoiceType,
      value: SelectOptions.invoiceType[0].value,
    },
    // {
    //   label: 'Trạng thái gửi hoá đơn',
    //   alias: 'Trạng thái HĐ',
    //   formName: 'isSent',
    //   options: SelectOptions.isSent,
    //   value: SelectOptions.isSent[0].value,
    // },
    {
      label: 'Mã bệnh nhân',
      alias: 'Mã bệnh nhân',
      formName: 'patientCode',
      // options: SelectOptions.isSent,
      value: null,
    },
  ]
  return arr
}
export const summaryDefaultValues = (params) => {
  /** @type {Array<FilterDefaultValueProp>} */
  const arr = [
    {
      label: 'Người lập hoá đơn',
      alias: 'Người lập',
      formName: 'accountIds',
      options: _.reduce(
        params.accounts,
        (prev, acc) => [
          ...prev,
          {
            value: acc.accountId,
            label: acc.fullname,
          },
        ],
        [{ value: null, label: 'Tất cả' }],
      ),
      value: null,
    },
  ]
  return arr
}

export const fullColumns = (params) => [
  {
    name: 'STT',
    id: 'stt',
    center: true,
    width: '100px',
    cell: (row, index) => (
      <p
        data-tag="allowRowEvents"
        className="d-flex justify-content-center font-weight-normal m-0 text-maxline-3"
      >
        {index + 1}
      </p>
    ),
  },
  {
    name: 'Ký hiệu',
    id: 'serial',
    center: true,
    width: '100px',
    cell: (row) => {
      let serial = row?.serial
      return <span className="m-0 text-maxline-2">{serial}</span>
    },
  },
  {
    name: 'Số hóa đơn',
    id: 'no',

    center: true,
    width: '100px',
    cell: (row) => {
      const invoiceNo = row?.no
      return (
        <div
          data-tag="allowRowEvents"
          className="text-dark-75 font-weight-bold m-0 text-maxline-3 d-flex align-items-center"
        >
          {invoiceNo ? Utils.padString(invoiceNo, 8, '0') : ''}
        </div>
      )
    },
  },
  {
    name: 'Ngày xuất HĐ',
    id: 'date',
    center: true,
    width: '120px',
    cell: (row) => {
      // const xml = reportHelper.readXmlString(row?.xmlString)
      // const ngayLap = xml ? $(xml).find('NLap').text() : row?.date
      const ngayLap = row?.date
      return (
        <p
          data-tag="allowRowEvents"
          className="text-dark-75  m-0 text-maxline-3"
        >
          {dayjs(ngayLap).isValid() ? dayjs(ngayLap).format('DD/MM/YYYY') : ''}
        </p>
      )
    },
  },
  {
    name: 'Người xuất',
    id: 'accountId',
    center: true,
    minWidth: '250px',
    cell: (row) => {
      return (
        <p
          style={{
            textAlign: 'left',
          }}
          data-tag="allowRowEvents"
          className="text-dark-75 m-0 text-maxline-3 w-100"
        >
          {params.accounts.find((acc) => acc.accountId === row?.accountId)
            ?.fullname ?? ''}
        </p>
      )
    },
  },
  {
    name: 'Mã bệnh nhân',
    id: 'patientCode',
    center: true,
    minWidth: '150px',
    cell: (row) => {
      return (
        <p
          style={{
            textAlign: 'left',
          }}
          data-tag="allowRowEvents"
          className="text-dark-75  m-0 text-maxline-3 w-100"
        >
          {row?.patientCode}
        </p>
      )
    },
  },
  {
    name: 'Tên bệnh nhân',
    id: 'customerCompanyName',
    center: true,
    minWidth: '250px',
    cell: (row) => {
      const customerCompanyName = row?.customerName || row?.customerCompanyName
      return (
        <p
          style={{
            textAlign: 'left',
          }}
          data-tag="allowRowEvents"
          className="text-dark-75 m-0 text-maxline-3 w-100"
        >
          {customerCompanyName}
        </p>
      )
    },
  },
  {
    name: 'Tổng tiền thanh toán',
    id: 'totalAfterTax',
    center: true,
    minWidth: '130px',
    cell: (row) => {
      const xml = reportHelper.readXmlString(row?.xmlString)
      const totalAfterTax = xml
        ? $(xml).find('TToan > TgTTTBSo').text()
        : row?.totalAfterTax
      return (
        <p
          style={{
            textAlign: 'right',
          }}
          data-tag="allowRowEvents"
          className="text-dark-75 m-0 text-maxline-3 w-100"
        >
          {Utils.valueFormatted(
            totalAfterTax,
            row?.numberFormat,
            params.sysConfig,
            'totalCost',
          )}
        </p>
      )
    },
  },
  {
    name: 'Mã tra cứu',
    id: 'searchCode',
    center: true,
    minWidth: '130px',
    cell: (row) => {
      return (
        <p
          data-tag="allowRowEvents"
          className="text-dark-75 m-0 text-maxline-3"
        >
          {reportHelper.getSearchCode(row?.invoiceCode, row?.lookupCode)}
        </p>
      )
    },
  },
  {
    name: 'Trạng thái',
    id: 'issueStatus',
    center: true,
    minWidth: '140px',
    cell: (row) => {
      return (
        <p
          data-tag="allowRowEvents"
          className={`m-0 badge badge-light-${reportHelper.getInvoiceStatusColor(
            row?.issueStatus,
          )}`}
          style={{ whiteSpace: 'nowrap' }}
        >
          {reportHelper.getInvoiceStatus(row?.issueStatus)}
        </p>
      )
    },
  },
]

export const summaryColumns = (params) => [
  {
    name: 'STT',
    id: 'stt',
    center: true,
    width: '100px',
    cell: (row, index) => (
      <p
        data-tag="allowRowEvents"
        className="d-flex justify-content-center font-weight-normal m-0 text-maxline-3"
      >
        {index + 1}
      </p>
    ),
  },
  {
    name: 'Người tạo',
    id: 'accountId',
    center: true,
    cell: (row) => {
      return (
        <p
          style={{
            textAlign: 'left',
          }}
          data-tag="allowRowEvents"
          className="text-dark-75 m-0 text-maxline-3 w-100"
        >
          {params.accounts?.find((acc) => acc.accountId === row?.accountId)
            ?.fullname ?? ''}
        </p>
      )
    },
  },
  {
    name: 'Tổng số hóa đơn',
    id: 'totalInvoices',
    center: true,
    // width: '100px',
    cell: (row) => (
      <p
        data-tag="allowRowEvents"
        className="d-flex justify-content-center font-weight-normal m-0 text-maxline-3"
      >
        {row.totalInvoices}
      </p>
    ),
  },
  {
    name: 'Tổng tiền',
    id: 'totalAmountAfterTax',
    // center: true,
    // width: '100px',
    cell: (row) => (
      <p
        data-tag="allowRowEvents"
        className="d-flex justify-content-center font-weight-normal m-0 text-maxline-3"
      >
        {Utils.valueFormatted(
          row.totalAmountAfterTax,
          row?.numberFormat,
          params.sysConfig,
          'totalCost',
        )}
        {/* {row.totalAmountAfterTax} */}
      </p>
    ),
  },
]
